import QTC_EXT_1 from "./QTC_EXT_1";
import CODY_EXT_1 from "./CODY_EXT_1";
export default {
  QTC_EXT_1,
  CODY_EXT_1,
};
